import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { TrimSpacesDirective } from '@directives/trim-spaces.directive';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ReactiveFormsModule, TrimSpacesDirective]
})
export class PasswordInputComponent {
    @Input()
    control!: FormControl;

    @Input()
    inputId?: string;

    @Input()
    inputName?: string;

    @Input()
    placeholder?: string;

    @Input()
    minLength?: number;

    @Input()
    maxLength?: number;

    isPasswordVisible: boolean;
    passwordVisibleIcon: SafeHtml;
    passwordNotVisibleIcon: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.passwordVisibleIcon = this.iconSanitizer.getIcon('passwordVisible');
        this.passwordNotVisibleIcon = this.iconSanitizer.getIcon('passwordNotVisible');

        this.isPasswordVisible = false;
        this.placeholder = 'Enter your password';
    }

    togglePasswordVisibility() {
        this.isPasswordVisible = !this.isPasswordVisible;
    }
}
